import { styled } from '@mui/system'
import { Colors } from 'constants/colors'

const Keyword = styled('p')({
  borderRadius: '20px',
  minWidth: '100px',
  background: Colors.backgroundDark,
  display: 'flex',
  textAlign: 'center',
  alignContent: 'center',
  justifyContent: 'center',
  padding: '5px 10px',
  margin: '5px',
  color: Colors.white,
  float: 'left',
  fontSize: '15px',
  boxShadow: 'rgba(156, 156, 156, 0.2) 0px 2px 8px 0px',
})

const KeywordStyle = { Keyword }

export default KeywordStyle
